import './Avatar.scss';

interface AvatarProps {
  name?: string;
  id?: string;
}

function getInitials(name?: string): string {
  if (!name) return '?';
  const segments = name.split(' ');
  let initials = '';
  if (segments[0]) initials += segments[0].substring(0, 1);
  if (segments[1]) initials += segments[1].substring(0, 1);
  return initials.toUpperCase();
}

function getColorIndex(id?: string): number {
  if (!id) return 0;
  return id.charCodeAt(0) % 10;
}

export function Avatar({ name, id }: AvatarProps) {
  const initials = getInitials(name);
  const colorIndex = getColorIndex(id);

  return (
    <div className={`avatar-v2 avatar-v2--color-${colorIndex}`}>
      {initials}
    </div>
  );
}
